import * as React from 'react';

export interface ServiceUnavailableEnhancerProperties {
    serviceUnavailable: boolean;
}

export function withServiceUnavailable<P extends ServiceUnavailableEnhancerProperties>(Component: React.ComponentType<P>) {
    return class ServiceUnavailableEnhancer extends React.Component<P> {
        render() {
            let serviceUnavailableMessage = (
                <div className="container dashboard d-flex w-100 align-items-center justify-content-center" style={{ height: '100vh' }}>
                    <section style={{ padding: '10%' }}>
                        <h1 className="title mt-0">Our service is temporarily unavailable.</h1>
                        <p className="subtitle">Rest assured, we are working hard to restore it! Your existing filespaces are unaffected by this outage and should continue to work normally.</p>
                    </section>
                </div>
            );

            return (
                <React.Fragment key="sameKey">
                    {this.props.serviceUnavailable && serviceUnavailableMessage}
                    {!this.props.serviceUnavailable && <Component {...this.props} />}
                </React.Fragment>
            );
        }
    };
}



// WEBPACK FOOTER //
// ./src/webportal/components/hocs/ServiceUnavailableEnhancer.tsx